import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { class: String }

  connect() {
    // If the current path contains a message ID…
    if (/^\/campaigns\/queue\/[0-9]+$/.test(window.location.pathname)) {
      const messageId = window.location.pathname.split("/")[3]
      const currentMessage = document.getElementById(`inbox-message-${messageId}`)

      // …and the message is visible in the list: select it.
      if (currentMessage) {
        this._setActive(currentMessage, false)
      }
    }
  }

  select(e) {
    this._setActive(e.currentTarget, true)
  }

  _setActive(el, scroll) {
    const targetFrame = document.getElementById(el.dataset.turboFrame)
    const selectedItems = document.querySelectorAll("[data-controller='campaign--inbox'] .selected")

    targetFrame.addEventListener("turbo:frame-load", function () {
      if (selectedItems) {
        selectedItems.forEach(function (item) {
          item.classList.remove("selected")
        })
      }

      this.firstChild.focus()
      el.parentElement.classList.add("selected")

      // Scroll to top of message if out of the viewport
      if (scroll) {
        const messageDetails = document.getElementById("messages-details")
        const messageDetailsTop = messageDetails.getBoundingClientRect().top

        // While that should not be necessary, we ensure that the URL is updated with the message ID
        // (/campaigns/queue/MESSAGE_ID)
        history.replaceState(null, document.title, el.href)

        if (messageDetailsTop < 0) {
          messageDetails.scrollIntoView({ behavior: "smooth" })
        }
      }
    })
  }
}
